import { criterioTextoLivre, montaBusca } from '../../dispositivos/core/buscaDsl'
import { somenteDigitos } from './formularioFornecedor'
import { TipoFornecedor } from './_models'

export type FiltroFornecedores = {
  texto?: string
  cnpj?: string
  ativo?: boolean
  tipos?: TipoFornecedor[]
}

/** `search` da listagem de fornecedores: texto em razão social ou nome fantasia, CNPJ só dígitos. */
export const buscaFornecedores = ({ texto, cnpj, ativo, tipos }: FiltroFornecedores) => {
  const digitos = somenteDigitos(cnpj)
  return montaBusca(
    criterioTextoLivre(['nome', 'nomeFantasia'], texto),
    digitos && `cnpj~*${digitos}*`,
    ativo !== undefined && `ativo:${ativo}`,
    !!tipos?.length && `tipos:${tipos.join('|')}`
  )
}
